enum UserRole {
  Admin = 'admin',
  Alumni = 'alumni',
}

export default UserRole;
